<template lang="pug">
GenericCard.await-shipment-list(size='auto')
  .d-flex.align-items-center.justify-content-between.p-3
    .d-flex
      .text-large รายการรอจัดส่ง
      LoadingIndicator.ml-2(v-if='isLoading')
    CustomDatePicker(v-model='filterDate')
  hr.m-0
  .pt-2.pb-2.px-3
    CustomTable(
      :columns='tableCols'
      :data='tableData'
    )
  .sticky-bottom.bg-white
    hr.m-0
    .px-4.py-3
      CustomPagination(
        v-model='currentPage'
        :total='totalPage'
      )
</template>

<script>
/* eslint-disable arrow-body-style */
export default {
  computed: {
    filteredTableData() {
      if (this.tableData) {
        return this.tableData.filter((item) => {
          return (this.filterDate === '') || (this.$dateUtils.isInRange(item.sellDate, this.filterDate));
        });
      }
      return [];
    },
  },
  watch: {
    filterDate() {
      this.currentPage = 1;
      this.loadData();
    },
    currentPage() {
      this.loadData();
    },
  },
  data: () => ({
    tableCols: {
      // no: {
      //   title: 'ลำดับ',
      //   align: 'center',
      // },
      customerName: {
        title: 'ชื่อลูกค้า',
        align: 'left',
        computed: val => val.customer.name,
      },
      entryNo: {
        title: 'เลขที่รายการ',
        align: 'left',
        type: 'EntryNo',
      },
      created_at: {
        title: 'วันที่อนุมัติบิล',
        align: 'center',
        type: Date,
      },
      total: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
      },
    },
    tableData: [],
    filterDate: '',
    isLoading: false,
    currentPage: 1,
    totalPage: 1,
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      const res = await this.$api.user.awaitShipmentList(
        this.currentPage,
        this.filterDate,
      );
      if (res.status === 200) {
        this.tableData = res.data.data;
        this.currentPage = res.data.current_page;
        this.totalPage = res.data.last_page;
        this.$emit('finishLoading', res.data);
      }

      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss">
.filter-date {
  font-size: 20px;
}
</style>
